import Vue from "vue";
import App from "./App.vue";
// import customerRouter from "@/router/customer";
import router from "@/router";
import vuetify from "./plugins/vuetify";
import store from "@/store";
import Api from "@/common/api";

Vue.config.productionTip = false;
// Vue.config.devtools = true;

Api.init();

// const currentRouter = window.location.pathname.startsWith("/customer")
//   ? customerRouter
//   : router;

// console.log("currentRouter", currentRouter);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
